import type { StripeRedirect } from '@octopus-do/octopus-api-client'
import { LoaderActions } from '@store/loaders'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'

export function* requestBillingPortal() {
  try {
    yield put(LoaderActions.set('billing'))
    document.body.classList.remove('--loaded')

    const { url }: StripeRedirect = yield call(
      NestClient.subscription.billingPortal
    )

    if (url) {
      window.location.href = url
    } else {
      yield put(LoaderActions.unset('billing'))
      document.body.classList.add('--loaded')

      yield put(
        notificationActionCreators.setNotification({
          type: NotificationType.SOMETHING_WENT_WRONG_ERROR,
        })
      )
    }
  } catch (error) {
    console.error('Error requesting billing portal:', error)

    yield put(LoaderActions.unset('billing'))
    document.body.classList.add('--loaded')

    yield put(
      notificationActionCreators.setNotification({
        type: NotificationType.SOMETHING_WENT_WRONG_ERROR,
      })
    )
  }
}
